module.exports = {
  "actionsLibInteraction": {
    "name": "Asset actions interaction",
    "class": "interaction",
    "properties": {
      "applicationId": {
        "type": "string"
      },
      "objectType": {
        "type": "string"
      },
      "objectId": {
        "type": "number"
      },
      "action": [
        "open-dropdown",
        "click-action"
      ],
      "actionType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "asset-actions-lib",
    "version": "1"
  }
};